import styled from 'styled-components';

export const ModalHeader = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const ModalTitle = styled.h5`
  margin: 0;
  font-size: 1.25em;
  font-weight: bold;
`;

export const ModalBody = styled.section`
  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
`;

export const ModalFooter = styled.section`
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
`;
